import {
  PARTICIPANT_ROLE_CAPABILITIES,
  type ParticipantRole,
  type ParticipantRoleCapabilities,
} from './roles.ts';

/** Who may drive playback in a screening. New policies are added as a registry entry. */
export const CONTROL_POLICIES = ['hosts', 'everyone'] as const;
export type ControlPolicy = (typeof CONTROL_POLICIES)[number];

export interface ControlPolicyDefinition {
  /** Guests may play, pause and seek. */
  readonly guestsControlPlayback: boolean;
}

export const CONTROL_POLICY_DEFINITIONS = {
  hosts: { guestsControlPlayback: false },
  everyone: { guestsControlPlayback: true },
} as const satisfies Record<ControlPolicy, ControlPolicyDefinition>;

export const DEFAULT_CONTROL_POLICY: ControlPolicy = 'hosts';

/**
 * Effective capabilities of a participant in a room. This is the single business rule that the
 * server enforces and the client mirrors to decide which controls to show.
 */
export const participantCapabilities = (
  role: ParticipantRole,
  policy: ControlPolicy,
): ParticipantRoleCapabilities => {
  const base = PARTICIPANT_ROLE_CAPABILITIES[role];
  return {
    ...base,
    controlPlayback: base.controlPlayback || CONTROL_POLICY_DEFINITIONS[policy].guestsControlPlayback,
  };
};
